import { HttpClient } from '@angular/common/http';
import { BaseService } from '../../system-common/services/base.service';
import { SettingService } from '../../system-common/services/setting.service';

export class DocumentManagementServiceHandler extends BaseService {
  constructor(http: HttpClient, settingService: SettingService) {
    super(http, settingService, 'DOCUMENT');
  }

  public init(modelNameList: string[]) {
    return null;
  }

  public load(id: any, modelNameList: string[], isMetadataReqd?: boolean) {
    return null;
  }

  public process(id: any, modelNameList: string[]) {
    return null;
  }

  public find(executeSearch?: boolean, searchCriteriaData?: any) {
    return this.getDocumentSearchList(executeSearch, searchCriteriaData);
  }

  private getDocumentSearchList(executeSearch?: boolean, searchCriteriaData?: any) {
    return this.getSearchList('DocumentSearch', executeSearch, searchCriteriaData);
  }

  getDocument(id: number) {
    let body = {
      id: id,
    };
    let path = this.getURLValue('DOCUMENT');
    return this.httpPost(`${path}/downloadCompanyDocument`, body, null, true);
  }
}
